import { createSelector } from '@ngrx/store';
import { getDragonflyState } from '../reducers';

export const getUserSearchState = createSelector(getDragonflyState, (state) => state.userSearch);

export const getPanelExpanded = createSelector(getUserSearchState, ({ panelExpanded }) => panelExpanded);

export const getUserName = createSelector(getUserSearchState, ({ userName }) => userName);

export const getDisplayedName = createSelector(getUserSearchState, ({ displayedName }) => displayedName);

export const getEmail = createSelector(getUserSearchState, ({ email }) => email);

export const getSecurityGroupValues = createSelector(
  getUserSearchState,
  ({ securityGroupValues }) => securityGroupValues,
);

export const getSecurityGroup = createSelector(getUserSearchState, ({ securityGroup }) => securityGroup);

export const getBusinessGroupValues = createSelector(
  getUserSearchState,
  ({ businessGroupValues }) => businessGroupValues,
);

export const getBusinessGroup = createSelector(getUserSearchState, ({ businessGroup }) => businessGroup);

export const getDeactivated = createSelector(getUserSearchState, ({ deactivated }) => deactivated);

export const getQuicksight = createSelector(getUserSearchState, ({ quicksight }) => quicksight);

export const getSecurityGroupId = createSelector(getUserSearchState, ({ securityGroup, securityGroups }) =>
  securityGroup
    ? securityGroups.reduce((secGroups: any, secGroup: any) => {
        if (secGroup.securityGroupName === securityGroup) {
          secGroups.push(secGroup.securityGroupId);
        }
        return secGroups;
      }, [] as string[])[0]
    : null,
);

export const getRawSecurityGroups = createSelector(getUserSearchState, ({ securityGroups }) => securityGroups);

export const getRawBusinessGroups = createSelector(getUserSearchState, ({ businessGroups }) => businessGroups);

export const getBusinessGroupId = createSelector(getUserSearchState, ({ businessGroup, businessGroups }) =>
  businessGroup && businessGroups
    ? (businessGroups.find((bsnsGroup: any) => bsnsGroup.businessGroupName === businessGroup).businessGroupId ?? null)
    : null,
);

export const getSearchEnabled = createSelector(
  getRawSecurityGroups,
  getRawBusinessGroups,
  (securityGroups, businessGroups) => !securityGroups || !businessGroups,
);
